<!-- Paid Full Sidebar -->
<!-- (onHide)="setHideSideBar($event)"  -->
<p-drawer [visible]="showPaidFullSidebar()" (onHide)="onBillingSidebarHide()" [showCloseIcon]="false" position="right" [blockScroll]="true" 
  [styleClass]="'w-full payment-sidebar no-header p-0' + (isPaymentFlowBlockingUi ? ' payment-flow-blocked' : '')"
  [dismissible]="false" [closeOnEscape]="!isPaymentFlowBlockingUi" 
  [autoZIndex]="true" [appendTo]="'body'">

  <ng-template #header>
    <!-- Header -->
    <div class="border-bottom-1 border-300 flex align-items-center sticky left-0 top-0 w-full surface-0 z-5 pb-2">
      <!-- Close Button -->
      @if (!isPaymentFlowBlockingUi) {
        <div (click)="closeBillingSideBar('')" class="h-2-5rem w-2-5rem cursor-pointer surface-100 hover:surface-200 transition-colors duration-200 flex align-items-center justify-content-center border-round" [attr.aria-label]="'close-billing-summary-sidebar'" [attr.data-testid]="'close-billing-summary-sidebar'">
          <i class="fa fa-times text-lg text-500 hover:text-700 transition-colors duration-200"></i>
        </div>
      }
      <div class="flex align-items-center w-full ml-2">
        <div class="flex align-items-center gap-3">
          <div class="flex align-items-center gap-2">
            <i class="fa fa-file-invoice text-primary text-lg"></i>
            @if (billingSignupMode === signUpMode.SignUp) {
              <h4 class="mb-0 mr-1 md:mr-2 text-sm">{{'POS.MEMBERSHIP_ADDON.BILL_SUMMARY' | translate}}</h4>
            }
            @if (billingSignupMode === signUpMode.Upgrade) {
              <h4 class="mb-0 mr-1 md:mr-2 text-sm">{{'POS.MEMBERSHIP_ADDON.UPGRADE_SUMMARY' | translate}}</h4>
            }
            @if (billingSignupMode === signUpMode.MidCycleAddons) {
              <h4 class="mb-0 mr-1 md:mr-2 text-sm">{{'POS.MEMBERSHIP_ADDON.ADD_ON_SUMMARY' | translate}}</h4>
            }
          </div>

          <!-- Client Details in Header -->
          @if (hasbillingRights) {
            <div class="flex align-items-center gap-2 border-left-1 border-200 pl-3">
              <billing-client-info [planSummarydata]="planSummary$() | async" [showSkeleton]="showSkeleton$" (ChangeBillingNameEvent)="ChangeBillingNameEvent($event)" />
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Header -->
  </ng-template>

  <ng-template #content>
    <form [formGroup]="fg" class="h-screen flex flex-column justify-content-between">
      <!-- Content -->
      <div>
        @if (!hasbillingRights) {
          <div class="md:pt-3 pt-2 md:px-4 px-3 pb-8">
            <div class="flex justify-content-between">
              <h1 class="text-lg md:text-2xl text-900 font-normal mr-2 mb-0 line-height-1">
                {{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}
                <i class="fa fa-question-circle font-light text-xl text-600 cursor-pointer" pTooltip="{{ 'POS.MEMBERSHIP_ADDON.POS-CHARGES' | translate }}" tooltipStyleClass="text-xs"></i>
              </h1>
              <div>
                <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}" icon="fa fa-lock" styleClass="text-sm hidden md:flex" (click)="RequestAccess()" [attr.aria-label]="'request-billing-access-button'" [attr.data-testid]="'request-billing-access-button'" />
                <p-button icon="fa fa-lock" styleClass="text-sm md:hidden" [attr.aria-label]="'request-billing-access-button-mobile'" [attr.data-testid]="'request-billing-access-button-mobile'" />
              </div>
            </div>
            <hr class="border-300 border-top-1 border-bottom-none border-left-none border-right-none my-3" />
            <!-- Card -->
            <div class="surface-0 shadow-2 pb-6">
              <p-message severity="error" icon="fa fa-times" aria-label="access-denied-message">
                {{ 'POS.MEMBERSHIP_ADDON.YOU_DONT_HAVEACCESS' | translate }}
              </p-message>
              <div class="text-center mt-6">
                <img src="/assets/img/no-data-img.svg" alt="Request Access" />
                <br />
                <p-button label="{{ 'POS.MEMBERSHIP_ADDON.REQUEST_ACCESS' | translate }}" icon="fa fa-lock" styleClass="text-sm mt-5" (click)="RequestAccess()" />
              </div>
            </div>
            <!-- Card -->
          </div>
        }

        @if (hasbillingRights) {
          <div>
            <!-- Info Card -->
            @if (billingSignupMode === signUpMode.SignUp) {
              <div class="shadow-2 border-round p-3 mx-3 my-2">
                <!-- Dropdown -->
                @if (disablePlanDropdown && (showSkeleton$ | async) === false) {
                  <p-select
                    [options]="planSubscription$.value"
                    formControlName="ddlplanSubscriptionList"
                    optionLabel="name_primary_language"
                    filterBy="name_primary_language"
                    [filter]="true"
                    styleClass="w-full text-sm"
                    placeholder="{{'POS.MEMBERSHIP_ADDON.SELECT_PRODUCT' | translate}}"
                    [attr.aria-label]="'select-membership-plan-dropdown'"
                    [attr.data-testid]="'select-membership-plan-dropdown'">
                    <ng-template pTemplate="selectedItem">
                      @if (planList) {
                        <div class="flex align-items-center text-xs md:text-sm">
                          @if (planList.value.subscription_category) {
                            <span class="bg-blue-50 uppercase px-2 py-1 border-round text-primary border-1 border-primary text-xxs">
                              {{'POS.PLANTYPE.' + planList.value.subscription_category.toUpperCase() | translate }}
                            </span>
                          }
                          <span class="mx-2">
                            {{getLocalizedFieldData(planList.value.name_primary_language,planList.value.name_secondary_language) | async}}
                          </span>
                          <strong>
                            {{getPlanAmount(planList.value) | currencyformat}}
                          </strong>
                        </div>
                      }
                    </ng-template>
                    <ng-template let-memberships pTemplate="item">
                      <div class="flex align-items-center text-xxs md:text-sm" [attr.data-testid]="'membership-item-'+memberships.name_primary_language" [attr.aria-label]="'membership-item-'+memberships.name_primary_language">
                        @if (memberships.subscription_category) {
                          <span class="bg-blue-50 uppercase px-2 py-1 border-round text-primary border-1 border-primary text-xxs">
                            {{'POS.PLANTYPE.' + memberships.subscription_category.toUpperCase() | translate }}
                          </span>
                        }
                        <span
                          class="mx-2 w-8rem overflow-hidden white-space-nowrap text-overflow-ellipsis"
                          pTooltip="{{getLocalizedFieldData(memberships.name_primary_language,memberships.name_secondary_language) | async}}"
                          tooltipStyleClass="text-xs">
                          {{getLocalizedFieldData(memberships.name_primary_language,memberships.name_secondary_language) | async}}
                        </span>
                        <strong>
                          {{getPlanAmount(memberships) | currencyformat}}
                        </strong>
                      </div>
                    </ng-template>
                  </p-select>
                }
                @if (showSkeleton$ | async) {
                  <p-skeleton width="100%" height="2rem" />
                }
                @if (planDetail; as obj;) {
                  @if (disablePlanDropdown && (showSkeleton$ | async) === false) {
                    <div class="mt-3"></div>
                  }
                  <div class="flex align-items-start justify-content-between mb-2 md:mb-0">
                    @if (isPlanSelected && (showSkeleton$ | async) === false && obj.subscription_category) {
                      <div class="bg-blue-50 uppercase white-space-nowrap mr-2 inline-block p-1 border-round text-primary text-xxs border-primary border-1">
                        {{'POS.PLANTYPE.' + obj.subscription_category.toUpperCase() | translate }}
                      </div>
                    }
                    @if (showSkeleton$ | async) {
                      <p-skeleton width="100%" height="1.2rem" styleClass="mt-2" />
                    }
                    <!-- Price -->
                    <div class="white-space-nowrap ml-4 text-lg text-right">
                      @if (isPlanBehaviourRecurring(obj.subscription_category) && (showSkeleton$ | async) === false) {
                        @if (recurringCost$ | async; as recurringCost) {
                          <strong>
                            {{ recurringCost | currencyformat }}
                          </strong>
                        }
                        <sub class="text-xs">
                          / {{ (this.billingInterval> 1)? this.billingInterval.toString() : ""}} {{ 'POS.MEMBERSHIP_ADDON.' + this.getInterval(this.billingInterval,this.biilingIntervalType) | translate}}
                        </sub>
                        <i class="block text-600 text-xxs">
                          {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}
                        </i>
                      }
                      @if (!isPlanBehaviourRecurring(obj.subscription_category) && (showSkeleton$ | async) === false) {
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong>
                            {{ totalOneTimeCost | currencyformat }}
                          </strong>
                        }
                        <i class="block text-600 text-xxs">
                          {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}
                        </i>
                      }
                    </div>
                    <!-- Price -->
                  </div>
                  <!-- Heading -->
                  <div>
                    @if (isPlanSelected && (showSkeleton$ | async) === false) {
                      <h3 class="text-sm mb-0 overflow-hidden text-overflow-ellipsis white-space-nowrap">
                        {{ getLocalizedFieldData(obj.name_primary_language,obj.name_secondary_language) | async}}
                      </h3>
                    }
                    @if (showSkeleton$ | async) {
                      <p-skeleton styleClass="w-6rem mb-2" height="1.35rem" />
                    }
                    @if ((showSkeleton$ | async) === false && isPlanSelected) {
                      <p class="text-xs text-600 mb-0" [innerHTML]="getLocalizedFieldData(obj.description_primary_language,obj.description_secondary_language) | async">
                      </p>
                    }
                    @if (showSkeleton$ | async) {
                      <p-skeleton styleClass="w-6rem mb-2" height="1.35rem" />
                    }
                  </div>
                  @if ((showSkeleton$ | async) === false) {
                    <p class="mb-0 md:mb-1 mt-2 text-xs text-600 border-bottom-1 border-top-1 border-300 py-2"  [ngClass]="allServiceNameHtml(obj) !== ' ' ? '' : 'hidden'"
                      [innerHTML]="allServiceNameHtml(obj)">
                    </p>
                  }
                  <!-- Heading -->
                  @if ((showSkeleton$ | async)) {
                    <p-skeleton styleClass="mt-2" width="100%" height="1.35rem" />
                  }
                  <!-- Features -->
                  <div class="grid -mb-2 mt-1 text-xs rtl-row-reverse">
                    <!-- <div class="-mt-2 w-full" *ngIf="isPresaleTenant.value">
                    <p-message severity="info" styleClass="relative" aria-label="presale-info-message">
                      {{'POS.MEMBERSHIP_ADDON.PRESALE_INFO' | translate}}
                    </p-message>
                  </div> -->
                  <div class="col-12 md:col-6">
                    <h5 class="font-medium text-700 text-xs mb-2 uppercase">
                      {{'POS.MEMBERSHIP_ADDON.START_DATE' | translate}}
                    </h5>
                    @if (false) {
                      <div class="inline-flex align-items-center border-1 border-300 border-round pr-1">
                        <div class="p-inputgroup opacity-60">
                          <span class="p-inputgroup-addon border-left-none border-top-none border-bottom-none"><i class="fa fa-calendar"></i></span>
                          <p-datepicker
                            icon="fa fa-calendar font-light"
                            formControlName="subscriptionstartdate"
                            inputStyleClass="text-sm"
                            styleClass="w-full opacity-40 pointer-events-none"
                            [locale]="locale"
                            [minDate]="presaleMinDate"
                            (onSelect)="GetRevisedPrice_OnStartDateChange()"
                            [maxDate]="canByPassMaxSubscriptionStartDate ? null : calendarMaxDate"
                            [disabledDates]="canByPassMaxSubscriptionStartDate ? [] : calendarDisabledDates">
                            [attr.aria-label]="'presale-subscription-start-date'"
                            [attr.data-testid]="'presale-subscription-start-date'">
                          </p-datepicker>
                        </div>
                        <p-tag styleClass="text-xxs font-normal uppercase bg-purple-500 font-bold ml-2 white-space-nowrap">{{'POS.MEMBERSHIP_ADDON.PRESALE' | translate}}</p-tag>
                      </div>
                    }
                    <!-- Datepicker -->
                    @if ((showSkeleton$ | async) === false) {
                      <p-datepicker [showIcon]="true"
                        formControlName="subscriptionstartdate"
                        inputStyleClass="text-sm"
                        styleClass="w-full"
                        [locale]="locale"
                        (onSelect)="GetRevisedPrice_OnStartDateChange()"
                        [attr.aria-label]="'select-subscription-start-date'"
                        [attr.data-testid]="'select-subscription-start-date'"
                        [maxDate]="canByPassMaxSubscriptionStartDate ? null : calendarMaxDate"
                        [minDate]="isPresaleTenant.value ? presaleMinDate : null"
                        [disabledDates]="canByPassMaxSubscriptionStartDate ? [] : calendarDisabledDates" />
                    }
                    @if ((showSkeleton$ | async)) {
                      <p-skeleton width="100%" height="2rem" />
                    }
                  </div>
                  @if (isPlanBehaviourRecurring(obj.subscription_category)) {
                    <div class="col-12 md:col-6">
                      <h5 class="font-medium text-700 text-xs mb-2 uppercase">{{'POS.MEMBERSHIP_ADDON.BILLING_CYCLE' | translate}}</h5>
                      @if ((showSkeleton$ | async) === false && billingCycleOption$ | async; as cycleOption) {
                        <p-select
                          [options]="cycleOption"
                          formControlName="ddlBillingCycle"
                          optionLabel="name"
                          filterBy="name"
                          styleClass="w-full text-sm"
                          placeholder="{{'common.PLACEHOLDER.SELECT' |  translate}}"
                          (onChange)="GetRevisedPrice_OnCycleChange()"
                          [attr.aria-label]="'select-billing-cycle-dropdown'"
                          [attr.data-testid]="'select-billing-cycle-dropdown'">
                          <ng-template pTemplate="selectedItem">
                            @if (billingCycle.value) {
                              <div class="text-sm">
                                {{billingCycle.value.name}}
                              </div>
                            }
                          </ng-template>
                          <ng-template let-billingCycle pTemplate="item">
                            <div class="text-sm">
                              {{billingCycle.name}}
                            </div>
                          </ng-template>
                        </p-select>
                      }
                      @if ((showSkeleton$ | async)) {
                        <p-skeleton width="100%" height="2rem" />
                      }
                    </div>
                  }
                </div>
                <!-- Features -->
              }
            </div>
          }
          <!-- Info Card -->
          <!-- Info Card Upgrade -->
          @if (billingSignupMode === signUpMode.Upgrade) {
            <upgrade-membership-info [showSkeleton]="showSkeleton$"
              [showInfo]="true"
              [showCalculation]="false"
              [planMaster]="(selectedPlanDetail$ | async)"
              [fromSubscription]="fromSubscription"
              [subscriptionStartDate]="subscriptionStartdate.value" />
          }
          <!-- Info Card Upgrade-->
          <!-- Info Card Upgrade -->
          @if (fromSubscription && fromSubscription.id && fromSubscription.id > 0 && billingSignupMode === signUpMode.MidCycleAddons) {
            <div class="px-3 py-2">
              <div class="flex align-items-center justify-content-between">
                <div class="flex align-items-center">
                  @if (fromSubscription.subscription_category) {
                    <span class="bg-blue-50 px-2 py-1 border-round text-primary border-1 border-primary text-xs">
                      {{'POS.PLANTYPE.' + fromSubscription.subscription_category.toUpperCase() | translate }}
                    </span>
                  }
                  <h3 class="font-normal text-sm mb-0 mx-2 flex flex-wrap align-items-center">
                    <span class="max-w-9rem md:max-w-11rem overflow-hidden text-overflow-ellipsis white-space-nowrap mr-2">
                      {{ getLocalizedFieldData(fromSubscription.name_primary_language,fromSubscription.name_secondary_language) | async }}
                    </span>
                  </h3>o
                </div>
                <div class="text-sm md:text-lg text-right white-space-nowrap">
                  @if (isPlanBehaviourRecurring(fromSubscription.subscription_category) && (showSkeleton$ | async) === false) {
                    <strong>
                      {{ fromSubscription.recurring_revenue | currencyformat }}
                    </strong>
                    <sub class="text-xs">
                      / {{ (fromSubscription.billing_interval_value> 1) ? fromSubscription.billing_interval_value.toString() : ""}} {{ 'POS.MEMBERSHIP_ADDON.' + this.getInterval(fromSubscription.billing_interval_value,fromSubscription.billing_interval_type) | translate}}
                    </sub>
                    <i class="block text-600 text-xxs">
                      {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}
                    </i>
                  }
                  <!-- <ng-container *ngIf="!isPlanBehaviourRecurring(fromSubscription.subscription_category) && !(showSkeleton$ | async)">
                  <strong *ngIf="totalOneTimeCost$ | async as totalOneTimeCost">
                    {{ totalOneTimeCost | currencyformat }}
                  </strong>
                  <i class="block text-600 text-xxs">
                    {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}
                  </i>
                </ng-container> -->
              </div>
            </div>
            @if ((showSkeleton$ | async) === false) {
              <div class="bg-blue-50 border-round mt-2 p-3 text-xs text-700" [innerHTML]="allServiceNameForAddons()"></div>
            }
          </div>
        }
        <!-- Info Card Upgrade -->
        <!-- Select Addons -->
        @if (showAddonBilling.value && !(billingSignupMode === signUpMode.Upgrade || billingSignupMode  === signUpMode[signUpMode.Upgrade] || billingSignupMode === signUpMode.Amendment || billingSignupMode === signUpMode[signUpMode.Amendment]) && isTypeContract(subscription_category$.value)) {
          <div
            class="px-3 pt-2" [ngClass]="subscriptionPlanId === 0 ? 'opacity-40 pointer-events-none' : ''">
            <div (click)="SelectAddon()" class="p-3 text-sm cursor-pointer text-primary border-1 border-primary border-round flex align-items-center justify-content-between" [attr.data-testid]="'select-addon-button'">
              <div class="flex flex-wrap mr-2">
                @if (selectedAddons.value.length === 0) {
                  <strong class="text-primary">{{'BILLING_ADDONS.ADD_ONS' | translate }}</strong>
                }
                @if (selectedAddons.value.length > 0) {
                  <span class="text-900">{{'BILLING_ADDONS.SELCTED_ADD_ONS' | translate }}</span>
                }
                @for (addon of selectedAddons.value; track addon) {
                  <strong class="mx-1">{{addon.service_name_primary_language}}</strong>
                }
              </div>
              <i class="fa fa-chevron-right text-600"></i>
            </div>
          </div>
        }
        <!-- Select Addons -->
        @if (showAddonBilling.value && selectedAddons.value.length > 0 && !isAmendmentSignupMode()) {
          <div class="surface-0 shadow-2 border-round mt-2 px-3 py-2">
            <p-table [value]="selectedAddons.value" responsiveLayout="scroll" [loading]="tableLoading.getValue()">
              <ng-template pTemplate="header">
                <tr>
                  <th class="surface-0 text-xs text-600 border-none py-2 white-space-nowrap">{{'POS.MEMBERSHIP_ADDON.ADD_ON_DETAILS' | translate}}</th>
                  <th class="surface-0 text-xs text-600 border-none py-2 white-space-nowrap uppercase">{{'POS.MEMBERSHIP_ADDON.START_DATE' | translate}}</th>
                  <th class="surface-0 text-xs text-600 border-none py-2 white-space-nowrap uppercase">{{'POS.MEMBERSHIP_ADDON.EXPIRY_DATE' | translate}}</th>
                  <th class="surface-0 text-xs text-600 border-none py-2 white-space-nowrap"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-addon>
                <tr class="text-sm hover:surface-100">
                  <td class="py-2 white-space-nowrap">
                    <div class="white-space-nowrap w-12rem overflow-hidden text-overflow-ellipsis">
                      {{  getLocalizedFieldData(addon.plan_name_primary_language,addon.plan_name_secondary_language) | async }}
                      @if (addon.is_recurring && isExplimentoryMarkShow()) {
                        <i class="fa fa-exclamation-triangle text-yellow-500 ml-2 text-lg" [pTooltip]="'DEPOSIT.DEPOSIT_INFO_SIDEBAR' | depositTranslate" tooltipStyleClass="text-xs"></i>
                      }
                    </div>
                  </td>
                  @if (addon.is_recurring) {
                    <td class="py-2 white-space-nowrap"> {{ (addon.start_mode !== null ? 'BILLING_ADDONS.'+addon.start_mode : 'BILLING_ADDONS.SIGNUP_DATE') | translate }}</td>
                  }
                  @if (!addon.is_recurring) {
                    <td class="py-2 white-space-nowrap">{{ addon.start_date | date: 'MMM dd, yy' }}</td>
                  }
                  @if (addon.is_recurring) {
                    <td class="py-2 white-space-nowrap">{{ 'BILLING_ADDONS.EXP_RECURRING' | translate }}</td>
                  }
                  @if (!addon.is_recurring) {
                    <td class="py-2 white-space-nowrap">{{ getAddonEndDate(addon) | date: 'MMM dd, yy' }}</td>
                  }
                  <td class="py-2 white-space-nowrap"><i class="fa fa-trash-alt p-error cursor-pointer" (click)="removeAddon(addon)" [attr.data-testid]="'remove-addon-button'"></i></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <!-- Mid Part -->
        <div class="surface-50 border-top-1 border-300 mt-3">
          <div class="p-3">
            <!-- Apply Coupon -->
            <div  class="" [ngClass]="subscriptionPlanId === 0 ? 'opacity-40 pointer-events-none' : ''">
              <!-- Apply Coupon Button -->
              @if (!applyCoupon && !isCartFlow() && !isAmendmentSignupMode()) {
                <div class="surface-0 border-1 border-300 border-round px-3 h-3rem flex align-items-center justify-content-between cursor-pointer">
                  <div class="flex align-items-center text-sm line-height-1 w-full" (click)="ApplyCoupon()" [attr.aria-label]="'apply-coupon-button'" [attr.data-testid]="'apply-coupon-button'">
                    <i class="fa fa-percentage text-primary mr-2"></i>
                    @if (!couponApplied) {
                      <span>{{'POS.MEMBERSHIP_ADDON.APPLY_COUPON' | translate}}</span>
                    }
                    @if (couponApplied) {
                      <span>{{couponCodeFormControlValue}} <br /> </span>
                    }
                  </div>
                  @if (!couponApplied) {
                    <i class="fa fa-angle-right text-500 ml-3"></i>
                  }
                  @if (couponApplied) {
                    <i (click)="RemoveCouponCode(true)" class="cursor-pointer fa fa-times text-xl text-600 ml-3" [attr.aria-label]="'remove-coupon-button'" [attr.data-testid]="'remove-coupon-button'"></i>
                  }
                </div>
              }
              <!-- Apply Coupon -->
              <!-- Bill Details -->
              <div class="mt-3">
                <h5 class="text-sm mb-2">{{'POS.MEMBERSHIP_ADDON.BILLDETAILS' | translate}}</h5>
                @if ((planBreakUpCalculation$ | async); as billingBreakup) {
                  @if (!applyDiscount) {
                    <div class="border-1 border-300 border-round text-sm surface-0">
                      @if (subscription_category$ | async; as subscription_category;) {
                        @if (isContract$.getValue()) {
                          @if ((showSkeletonForBillDetails$ | async) === false && billingBreakup.charging_today.service_first_charge && billingBreakup.charging_today.service_first_charge.service_start_date &&  billingBreakup.charging_today.service_first_charge.service_prorata_days !== 0) {
                            <div class="px-3 py-3 flex align-items-center justify-content-between servicechargecontainer">
                              <div>
                                <div style="display: inline-flex;" [innerHTML]="'POS.MEMBERSHIP_ADDON.FIRSTCHARGE' | translate"></div>
                                (
                                <div style="display: inline-flex;" [innerHTML]="ordinalNumberNew(billingBreakup.charging_today.service_first_charge.service_start_date)"></div>
                                {{ monthName(billingBreakup.charging_today.service_first_charge.service_start_date) }} to
                                <div style="display: inline-flex;" [innerHTML]="ordinalNumberNew(billingBreakup.charging_today.service_first_charge.service_end_date)"></div>
                                {{ monthName(billingBreakup.charging_today.service_first_charge.service_end_date) }}
                                )
                              </div>
                              @if (netCost$ | async; as netCost) {
                                <div>
                                  {{ netCost | currencyformat }}
                                </div>
                              }
                            </div>
                          }
                          @if ((showSkeletonForBillDetails$ | async)) {
                            <div class="px-3 py-2 flex align-items-center justify-content-between">
                              <p-skeleton styleClass="w-4rem" height="1.35rem" />
                              <p-skeleton styleClass="w-4rem" height="1.35rem" />
                            </div>
                          }
                        }
                      }
                      @if (billingBreakup.charging_today.service_non_recurring.services && billingBreakup.charging_today.service_non_recurring.services.length > 0) {
                        @if ((showSkeletonForBillDetails$ | async) === false) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                            [attr.aria-label]="'non-recurring-service-' + planDetail?.non_recurring_services?.join('-')"
                            [attr.data-testid]="'non-recurring-service-' + planDetail?.non_recurring_services?.join('-')">
                            @if (planDetail; as serv) {
                              <span>
                                {{'POS.MEMBERSHIP_ADDON.ONETIMECHARGE' | translate}}
                                <br />
                                {{getConcatStringfromArray(serv.non_recurring_services)}}
                              </span>
                            }
                            @if (nonRecurringNetCost$ | async; as netCost) {
                              <span>
                                {{ netCost | currencyformat }}
                              </span>
                            }
                          </div>
                        }
                        @if ((showSkeletonForBillDetails$ | async)) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between"
                            [attr.aria-label]="'non-recurring-service-skeleton'"
                            [attr.data-testid]="'non-recurring-service-skeleton'">
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                          </div>
                        }
                      }
                      @if ((showSkeletonForBillDetails$ | async) === false && billingBreakup.charging_today.deposit && billingBreakup.charging_today.deposit.length > 0) {
                        @for (deposit of generateDepositOccurence(billingBreakup.charging_today.deposit); track deposit) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                            >
                            <span>{{ deposit.occurenceName}}</span>
                            <span>
                              {{ deposit.amount | currencyformat}}
                            </span>
                          </div>
                        }
                      }
                      @if ((showSkeletonForBillDetails$ | async)) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between">
                          <p-skeleton styleClass="w-4rem" height="1.35rem" />
                          <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        </div>
                      }
                      <!-- External Charges Section -->
                      @if (billingBreakup.charging_today.external_charges && billingBreakup.charging_today.external_charges.length > 0) {
                        <!-- External Charges Header -->
                        <div class="px-3 py-2 flex align-items-center gap-2 bg-orange-50 border-round">
                          <i class="fa fa-receipt text-orange-600 text-xs"></i>
                          <span class="text-xs font-medium text-orange-900">
                            {{ 'RETAIL_PRODUCTS.EXTERNAL_CHARGES' | translate }} ({{ billingBreakup.charging_today.external_charges.length }})
                          </span>
                        </div>
                        <!-- External Charges List -->
                        <div class="external-charges-container">
                          @for (charge of billingBreakup.charging_today.external_charges; track trackByChargeId($index, charge)) {
                            <div
                              class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                              >
                              <!-- Charge Info -->
                              <div class="flex align-items-center gap-2 flex-1">
                                <div class="w-1-5rem h-1-5rem bg-orange-100 border-round flex align-items-center justify-content-center flex-shrink-0">
                                  <i class="fa fa-tag text-orange-600 text-xs"></i>
                                </div>
                                <div class="flex-1">
                                  <div class="text-sm font-medium text-900 mb-1 line-height-2">
                                    {{ charge.name_primary_language }}
                                  </div>
                                  @if (charge.description_primary_language) {
                                    <div class="text-xs text-600">
                                      {{ charge.description_primary_language }}
                                    </div>
                                  }
                                  <span class="text-xs text-orange-800 font-medium">
                                    External charge
                                  </span>
                                </div>
                              </div>
                              <!-- Charge Price -->
                              <div class="text-right flex-shrink-0">
                                <div class="text-sm font-bold text-900">
                                  {{ charge.amount_in_minor_currency | currencyformat }}
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                      @for (charges of billingBreakup.charging_today.signup_charges; track charges) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer" [attr.data-testid]="'signup-charge-'+charges.name_primary_language" [attr.aria-label]="'signup-charge-'+charges.name_primary_language">
                          <span>{{charges.name_primary_language}}</span>
                          <span>
                            {{ getChargeNetCost(charges) | currencyformat}}
                          </span>
                        </div>
                        @if (!isInclusive && charges.tax && charges.tax.length > 0) {
                          @for (taxItem of charges.tax; track taxItem.id) {
                            <div class="px-3 py-1 flex align-items-center justify-content-between text-xs text-400 border-top-1 border-dashed border-100"
                              [attr.aria-label]="'charge-tax-'+charges.name_primary_language+'-'+taxItem.type"
                              [attr.data-testid]="'charge-tax-'+charges.name_primary_language+'-'+taxItem.type">
                              <span class="pl-3">└ {{ taxItem.type }} ({{ taxItem.rate }}%)</span>
                              <span>{{ taxItem.amt_in_minor_currency | currencyformat }}</span>
                            </div>
                          }
                        }
                        @if ((showSkeletonForBillDetails$ | async)) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between">
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                          </div>
                        }
                      }
                      <!-- Products Section -->
                      @if (billingBreakup.charging_today.products && billingBreakup.charging_today.products.length > 0) {
                        <!-- Products Header -->
                        <div class="px-3 py-2 flex align-items-center gap-2 bg-blue-50 border-round">
                          <i class="fa fa-cube text-blue-600 text-xs"></i>
                          <span class="text-xs font-medium text-blue-900">
                            {{ 'RETAIL_PRODUCTS.PRODUCTS' | translate }} ({{ billingBreakup.charging_today.products.length }})
                          </span>
                        </div>
                        <!-- Products List -->
                        <div class="products-container">
                          @for (product of billingBreakup.charging_today.products; track trackByProductId($index, product)) {
                            <div
                              class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer">
                              <!-- Product Info -->
                              <div class="flex align-items-center gap-2 flex-1">
                                <div class="w-1-5rem h-1-5rem bg-blue-100 border-round flex align-items-center justify-content-center flex-shrink-0">
                                  <i class="fa fa-box text-blue-600 text-xs"></i>
                                </div>
                                @if (getProductSKuDetails(product.sku_id); as productSku) {
                                  <div class="flex-1">
                                    <div class="text-sm font-medium text-900 mb-1 line-height-2">
                                      {{ productSku?.sku_name_primary_language || product.sku_name_primary_language }}
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                      <span class="text-xs px-1 py-0 bg-surface-100 border-round text-600">
                                        {{ productSku?.sku_code || 'N/A' }}
                                      </span>
                                      <span class="text-xs text-blue-800 font-medium">
                                        Qty: {{ product.quantity }}
                                      </span>
                                    </div>
                                  </div>
                                }
                              </div>
                              <!-- Product Price (taxable subtotal; line total incl. tax when applicable) -->
                              <div class="text-right flex-shrink-0">
                                <div class="text-sm font-bold text-900">
                                  @if (!isInclusive && getTaxAmount(product.tax) > 0) {
                                    {{ getProductLineTotal(product) | currencyformat }}
                                  } @else {
                                    {{ product.taxable_cost_in_minor_currency | currencyformat }}
                                  }
                                </div>
                                <div class="text-xs text-600">
                                  {{ (product.taxable_cost_in_minor_currency / product.quantity) | currencyformat }} × {{ product.quantity }}
                                  @if (!isInclusive && getTaxAmount(product.tax) > 0) {
                                    <span class="text-500"> + {{ getTaxAmount(product.tax) | currencyformat }} {{ 'POS.MEMBERSHIP_ADDON.TAXES' | translate }}</span>
                                  }
                                </div>
                              </div>
                            </div>
                            @if (!isInclusive && product.tax && product.tax.length > 0) {
                              @for (taxItem of product.tax; track taxItem.id) {
                                <div class="px-3 py-1 flex align-items-center justify-content-between text-xs text-400 border-top-1 border-dashed border-100"
                                  [attr.aria-label]="'product-tax-'+product.sku_id+'-'+taxItem.type"
                                  [attr.data-testid]="'product-tax-'+product.sku_id+'-'+taxItem.type">
                                  <span class="pl-3">└ {{ taxItem.type }} ({{ taxItem.rate }}%)</span>
                                  <span>{{ taxItem.amt_in_minor_currency | currencyformat }}</span>
                                </div>
                              }
                            }
                          }
                        </div>
                        @if (!isInclusive && getTotalProductTaxAmount(billingBreakup.charging_today.products) > 0) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between bg-blue-50 border-top-1 border-200"
                            aria-label="products-tax-total"
                            data-testid="products-tax-total">
                            <span class="text-xs font-medium text-blue-700">
                              <i class="fa fa-cube text-xs mr-1"></i>
                              {{'POS.MEMBERSHIP_ADDON.TAXES' | translate}} ({{'RETAIL_PRODUCTS.PRODUCTS' | translate}})
                            </span>
                            <span class="text-xs font-medium text-blue-700">{{ getTotalProductTaxAmount(billingBreakup.charging_today.products) | currencyformat }}</span>
                          </div>
                        }
                      }
                      @if (!isInclusive) {
                        @if ((showSkeletonForBillDetails$ | async) === false) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer">
                            <div class="cursor-pointer text-primary flex align-items-center" tooltipStyleClass="text-xs" tooltipPosition="top" pTooltip="">
                              <span class="mr-2">{{'POS.MEMBERSHIP_ADDON.TAXES' | translate}}</span><i class="fa fa-info-circle text-lg text-500 cursor-pointer" [attr.aria-label]="'taxes-info-icon'" [attr.data-testid]="'taxes-info-icon'"></i>
                            </div>
                            <span>
                              {{ getBillDetailsAggregateTax(billingBreakup.charging_today) | currencyformat }}
                            </span>
                          </div>
                        }
                        @if ((showSkeletonForBillDetails$ | async)) {
                          <div class="px-3 py-2 flex align-items-center justify-content-between">
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                            <p-skeleton styleClass="w-4rem" height="1.35rem" />
                          </div>
                        }
                      }
                      @if (isAmendmentSignupMode() && getAmendmentResidualCreditMinor() > 0) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                          aria-label="amendment-residual-credit"
                          data-testid="amendment-residual-credit">
                          <span>{{ 'AMENDMENT.RESIDUAL_CREDIT' | translate }}</span>
                          <span>-{{ getAmendmentResidualCreditMinor() | currencyformat }}</span>
                        </div>
                      }
                      @if (isAmendmentSignupMode() && getAmendmentConcessionDiscountMinor() > 0) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                          aria-label="amendment-concession-discount"
                          data-testid="amendment-concession-discount">
                          <span>{{ 'AMENDMENT.CONCESSION_DISCOUNT' | translate }}</span>
                          <span>-{{ getAmendmentConcessionDiscountMinor() | currencyformat }}</span>
                        </div>
                      }
                      @if (isAmendmentFutureStartWithBalanceAtStart()) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer"
                          aria-label="amendment-net-due-at-start"
                          data-testid="amendment-net-due-at-start">
                          <span>{{ 'AMENDMENT.NET_AMOUNT_DUE_AT_START' | translate }}</span>
                          <span>{{ getAmendmentNetDueAtStartMinor() | currencyformat }}</span>
                        </div>
                      }
                      @if (isAmendmentGymDeskPaymentRequired() && hasAmendmentTokenEnrollmentRequired()) {
                        <div class="px-3 py-2 text-sm text-700"
                          aria-label="amendment-gym-token-desk-payment-info"
                          data-testid="amendment-gym-token-desk-payment-info">
                          {{ 'AMENDMENT.GYM_TOKEN_DESK_PAYMENT_INFO' | translate }}
                        </div>
                      }
                      @if (!discountApplied && billingSignupMode !== signUpMode.MidCycleAddons && !isCartFlow() && !isAmendmentSignupMode()) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between">
                          <!-- Apply Discount Button -->
                          <p-button (click)="ApplyDiscount()" label="{{'POS.MEMBERSHIP_ADDON.APPLY_DISCOUNT' | translate}}" class="text-xs" styleClass="text-primary surface-0 py-1 border-400" [attr.aria-label]="'apply-discount-button'" [attr.data-testid]="'apply-discount-button'" />
                        </div>
                      }
                      @if (discountApplied && !isAmendmentSignupMode()) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between">
                          <!-- Edit Discount Button -->
                          <p-button (click)="ApplyDiscount()" label="{{'POS.MEMBERSHIP_ADDON.EDIT_DISCOUNT' | translate}}" class="text-xs" styleClass="text-primary surface-0 py-1 border-400" [attr.aria-label]="'edit-discount-button'" [attr.data-testid]="'edit-discount-button'" />
                          <!-- Remove Discount Button -->
                          <button
                            (click)="discountApplied=false;RemoveDiscount()"
                            pButton
                            type="button"
                            icon="fa fa-times text-xl-circle"
                            label="{{'POS.MEMBERSHIP_ADDON.REMOVE_DISCOUNT' | translate}}"
                            class="text-xs p-button-text -mr-3"
                            [attr.aria-label]="'remove-discount-button'"
                            [attr.data-testid]="'remove-discount-button'">
                          </button>
                        </div>
                      }
                      @if ((showSkeletonForBillDetails$ | async) === false) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom mt-2">
                          <span>{{'POS.MEMBERSHIP_ADDON.GRAND_TOTAL' | translate}}</span>
                          @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                            <span class="text-right">
                              {{totalOneTimeCost | currencyformat}}
                            </span>
                          }
                        </div>
                      }
                      @if ((showSkeletonForBillDetails$ | async)) {
                        <div class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom mt-2">
                          <p-skeleton styleClass="w-4rem" height="1.35rem" />
                          <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        </div>
                      }
                    </div>
                  }
                  <!-- Discount Area -->
                  @if (applyDiscount) {
                    <div>
                      <div [formGroup]="fgProducts">
                        <div class="border-1 border-300 border-round text-sm surface-0">
                          <div class="px-3 py-2 flex align-items-center justify-content-between">
                            <strong class="flex align-items-center">
                              {{'POS.MEMBERSHIP_ADDON.ONE_TIME_DISCOUNT'| translate}}
                              <i class="fa fa-question-circle font-light text-base text-500 ml-2 cursor-pointer" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
                            </strong>
                          </div>
                          @if (isContract$.getValue() && billingBreakup.charging_today.service_first_charge.services && billingBreakup.charging_today.service_first_charge.services.length > 0) {
                            <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer_edit">
                              <span class="flex align-items-center">
                                {{'POS.MEMBERSHIP_ADDON.FIRSTCHARGE' | translate}}
                                <i class="fa fa-question-circle font-light text-base text-500 ml-2 cursor-pointer" pTooltip="This is a sample!" tooltipStyleClass="text-xs"> </i>
                              </span>
                              <div class="flex align-items-center flex-wrap">
                                <span class="white-space-nowrap mr-2">
                                  {{getTotalBaseCost(billingBreakup.charging_today.service_first_charge.services) | currencyformat}}
                                </span>
                                <app-input-number [formGroup]="fgProducts" [controlName]="fgProducts.get('frmFirstTimeAmt')"
                                  [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                  [mode]="'decimal'" (onBlur)="calculateDiscount(frmFirstTimeBaseCostAmountFormControl, firstTimeAmountFormControl, firstTimeDiscountFormControl)"
                                  [attr.aria-label]="'first-time-amount-input'"
                                  [attr.data-testid]="'first-time-amount-input'" />
                                <app-input-number [formGroup]="fgProducts" [controlName]="firstTimeDiscountFormControl"
                                  [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                  [mode]="'decimal'" (onBlur)="calculateAmount(frmFirstTimeBaseCostAmountFormControl,firstTimeAmountFormControl, firstTimeDiscountFormControl)"
                                  [attr.aria-label]="'first-time-discount-input'"
                                  [attr.data-testid]="'first-time-discount-input'" />
                                <span class="p-inputgroup-addon">%</span>
                              </div>
                            </div>
                          }
                          @if (planDetail ; as serv;) {
                            @if (billingBreakup.charging_today.service_non_recurring.services && billingBreakup.charging_today.service_non_recurring.services.length > 0) {
                              <div
                                class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer_edit">
                                <span class="flex align-items-center">
                                  {{'POS.MEMBERSHIP_ADDON.ONETIMECHARGE' | translate}}<br />
                                  {{ getConcatStringfromArray(serv.non_recurring_services)}}
                                  <i class="fa fa-question-circle font-light text-base text-500 ml-2 cursor-pointer" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i>
                                </span>
                                <div class="flex align-items-center">
                                  <span class="white-space-nowrap mr-2">
                                    {{getTotalBaseCost(billingBreakup.charging_today.service_non_recurring.services) | currencyformat}}
                                  </span>
                                  <app-input-number [formGroup]="fgProducts" [controlName]="fgProducts.get('frmNonRecurringAmt')"
                                    [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateDiscount(frmNonRecurringBaseCostAmountFormControl,nonRecurringAmountFormControl, nonRecurringDiscountFormControl)"
                                    [attr.aria-label]="'non-recurring-amount-input'"
                                    [attr.data-testid]="'non-recurring-amount-input'" />
                                  <app-input-number [formGroup]="fgProducts" [controlName]="fgProducts.get('frmNonRecurringDis')"
                                    [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateAmount(frmNonRecurringBaseCostAmountFormControl,nonRecurringAmountFormControl, nonRecurringDiscountFormControl)"
                                    [attr.aria-label]="'non-recurring-discount-input'"
                                    [attr.data-testid]="'non-recurring-discount-input'" />
                                  <span class="p-inputgroup-addon">%</span>
                                </div>
                              </div>
                            }
                          }
                          <!-- Deposit Discount Section -->
                          @for (deposit of generateDepositOccurence(billingBreakup.charging_today.deposit); track trackByFn($index, deposit)) {
                            <div formArrayName="deposits" class="servicechargecontainer_edit">
                              <div [formGroupName]="0" class="px-3 py-2 flex align-items-center justify-content-between">
                                <span>{{deposit.occurenceName}}</span>
                                <div class="flex align-items-center">
                                  <span class="white-space-nowrap mr-2">{{deposit.amount | currencyformat}}</span>
                                  <app-input-number [formGroup]="fgProducts" [controlName]="getDepositControls('deposit_'+deposit.id)"
                                    [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateDepositDiscount(deposit.amount,'deposit_'+deposit.id, 'despositdiscount_'+deposit.id)"
                                    [attr.aria-label]="'deposit-amount-input'"
                                    [attr.data-testid]="'deposit-amount-input'" />
                                  <app-input-number [formGroup]="fgProducts" [controlName]="getDepositControls('despositdiscount_'+deposit.id)"
                                    [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateDepositAmount(deposit.amount,'deposit_'+deposit.id, 'despositdiscount_'+deposit.id)"
                                    [attr.aria-label]="'deposit-discount-input'"
                                    [attr.data-testid]="'deposit-discount-input'" />
                                  <span class="p-inputgroup-addon">%</span>
                                </div>
                              </div>
                            </div>
                          }
                          <!-- Charges Discount Section -->
                          @for (charges of (planBreakUpCalculation$ | async)?.charging_today?.signup_charges; track charges; let n = $index) {
                            <div formArrayName="charges" class="servicechargecontainer_edit">
                              <div [formGroupName]="0" class="px-3 py-2 flex align-items-center justify-content-between" [attr.data-testid]="'charge-discount-'+charges.name_primary_language" [attr.aria-label]="'charge-discount-'+charges.name_primary_language">
                                <span>{{charges.name_primary_language}}</span>
                                <div class="flex align-items-center">
                                  <span class="white-space-nowrap mr-2">{{charges.amount_in_minor_currency | currencyformat}}</span>
                                  <app-input-number [formGroup]="fgProducts" [controlName]="getControls('charges_'+charges.id)"
                                    [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                    [mode]="'decimal'"  (onBlur)="calculateChargeDiscount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                    [attr.aria-label]="'charge-amount-input-'+charges.name_primary_language"
                                    [attr.data-testid]="'charge-amount-input-'+charges.name_primary_language" />
                                  <app-input-number [formGroup]="fgProducts" [controlName]="getControls('discount_'+charges.id)"
                                    [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                    [mode]="'decimal'"  (onBlur)="calculateChargeAmount(charges.amount_in_minor_currency,'charges_'+charges.id, 'discount_'+charges.id)"
                                    [attr.aria-label]="'charge-discount-input-'+charges.name_primary_language"
                                    [attr.data-testid]="'charge-discount-input-'+charges.name_primary_language" />
                                  <span class="p-inputgroup-addon">%</span>
                                </div>
                              </div>
                            </div>
                          }
                          <!-- Products Discount Section -->
                          @for (product of (planBreakUpCalculation$ | async)?.charging_today?.products; track product; let n = $index) {
                            <div formArrayName="products" class="servicechargecontainer_edit">
                              @if (getProductControls('product_'+product.sku_id)) {
                                <div [formGroupName]="0" class="px-3 py-2 flex align-items-center justify-content-between" [attr.data-testid]="'product-discount-'+product.sku_id" [attr.aria-label]="'product-discount-'+product.sku_id">
                                  @if (getProductSKuDetails(product.sku_id); as productSku) {
                                    <div class="flex align-items-center gap-2">
                                      <span class="font-medium">{{ productSku.sku_name_primary_language }}</span>
                                      <span class="text-xs px-1 py-0 bg-surface-100 border-round text-600">
                                        Qty: {{ product.quantity }}
                                      </span>
                                    </div>
                                  }
                                  <div class="flex align-items-center">
                                    <span class="white-space-nowrap mr-2">{{ product.base_cost_in_minor_currency | currencyformat}}</span>
                                    <app-input-number [formGroup]="fgProducts" [controlName]="getProductControls('product_'+product.sku_id)"
                                      [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                      [mode]="'decimal'"  (onBlur)="calculateProductDiscount(product.base_cost_in_minor_currency,'product_'+product.sku_id, 'productdiscount_'+product.sku_id)"
                                      [attr.aria-label]="'product-amount-input-'+product.sku_id"
                                      [attr.data-testid]="'product-amount-input-'+product.sku_id" />
                                    <app-input-number [formGroup]="fgProducts" [controlName]="getProductControls('productdiscount_'+product.sku_id)"
                                      [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                      [mode]="'decimal'"  (onBlur)="calculateProductAmount(product.base_cost_in_minor_currency,'product_'+product.sku_id, 'productdiscount_'+product.sku_id)"
                                      [attr.aria-label]="'product-discount-input-'+product.sku_id"
                                      [attr.data-testid]="'product-discount-input-'+product.sku_id" />
                                    <span class="p-inputgroup-addon">%</span>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          <div class="p-3 border-top-1 border-300">
                            <label for="charges_reason" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate}}</label>
                            <textarea pInputTextarea formControlName="charges_reason" class="w-full h-4rem" placeholder="" [attr.aria-label]="'discount-reason-textarea'" [attr.data-testid]="'discount-reason-textarea'"></textarea>
                            @if (ChargesDiscountReason.touched && ChargesDiscountReason.invalid) {
                              <app-error-msg [errors]="ChargesDiscountReason.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate" />
                            }
                          </div>
                          @if (inValidDiscount) {
                            <div class="px-3 pb-3">
                              <p-message
                                severity="error"
                                icon="fa fa-exclamation-triangle"
                                styleClass="w-full m-0 flex align-items-start"
                                aria-label="invalid-discount-message"
                              >
                                {{ 'POS.MEMBERSHIP_ADDON.YOUCANNOTAPPLY' | translate }} {{ userDiscountLimit | number: '1.0-2' }} % {{ 'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate }}
                              </p-message>
                            </div>
                          }
                        </div>
                      </div>
                      <div [formGroup]="fgProductsRecurring">
                        @if (subscription_category$ | async; as subscription_category;) {
                          @if (isContract$.getValue()) {
                            <div class="border-1 border-300 border-round text-sm surface-0 mt-3">
                              <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer_edit">
                                <strong class="flex align-items-center">
                                  {{'POS.MEMBERSHIP_ADDON.RECURRING_DISCOUNT'| translate}}
                                  <i class="fa fa-question-circle font-light text-base text-500 ml-2 cursor-pointer" pTooltip="This is a sample!" tooltipStyleClass="text-xs"> </i>
                                </strong>
                              </div>
                              <div class="px-3 py-2 flex align-items-center justify-content-between servicechargecontainer_edit">
                                <span>{{'POS.MEMBERSHIP_ADDON.RECURRING_CHARGES'| translate}}</span>
                                <div class="flex align-items-center flex-wrap">
                                  @if (baseCostRecurring$ | async; as baseCost) {
                                    <span class="white-space-nowrap mr-2">{{ baseCost | currencyformat }}</span>
                                  }
                                  <app-input-number [formGroup]="fgProductsRecurring" [controlName]="fgProductsRecurring.get('frmRecurringMembershipAmt')"
                                    [styleClass]="'w-5rem h-2rem text-sm mr-2'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateRecurringDiscount(recurringMembershipBaseCostFormControl, recurringMembershipFormControl, recurringMembershipDiscountFormControl)"
                                    [attr.aria-label]="'recurring-membership-amount-input'"
                                    [attr.data-testid]="'recurring-membership-amount-input'" />
                                  <app-input-number [formGroup]="fgProductsRecurring" [controlName]="fgProductsRecurring.get('frmRecurringMembershipDis')"
                                    [styleClass]="'w-4rem h-2rem text-sm'" [conditionToFormat]="false"
                                    [mode]="'decimal'" (onBlur)="calculateRecurringAmount(recurringMembershipBaseCostFormControl,recurringMembershipFormControl, recurringMembershipDiscountFormControl)"
                                    [attr.aria-label]="'recurring-membership-discount-input'"
                                    [attr.data-testid]="'recurring-membership-discount-input'" />
                                  <span class="p-inputgroup-addon">%</span>
                                </div>
                              </div>
                              <div class="p-3 border-top-1 border-300">
                                <label for="recurring_reason" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate}}</label>
                                <textarea pInputTextarea formControlName="recurring_reason" class="w-full h-4rem" placeholder="" [attr.aria-label]="'recurring-discount-reason-textarea'" [attr.data-testid]="'recurring-discount-reason-textarea'"></textarea>
                                @if (RecurringDiscountReason.touched && RecurringDiscountReason.invalid) {
                                  <app-error-msg [errors]="RecurringDiscountReason.errors"
                                    [fieldLabel]="'POS.MEMBERSHIP_ADDON.DISCOUNT_REASON' | translate" />
                                }
                              </div>
                              @if (inValidRecurringDiscount) {
                                <div class="px-3 pb-3">
                                  <p-message
                                    severity="error"
                                    icon="fa fa-exclamation-triangle"
                                    styleClass="w-full m-0 flex align-items-start"
                                    aria-label="invalid-recurring-discount-message"
                                  >
                                    {{ 'POS.MEMBERSHIP_ADDON.YOUCANNOTAPPLY' | translate }} {{ userDiscountLimit | number: '1.0-2' }} % {{ 'POS.MEMBERSHIP_ADDON.DISCOUNT' | translate }}
                                  </p-message>
                                </div>
                              }
                            </div>
                          }
                        }
                      </div>
                      <div class="flex align-items-center justify-content-between mt-3">
                        <!-- Cancel Discount Button -->
                        <button (click)="applyDiscount=false;StaffDiscountCancel();" pButton type="button" label="{{'common.PLACEHOLDER.CANCEL' | translate}}" class="text-sm p-button-text" [attr.aria-label]="'cancel-discount-button'" [attr.data-testid]="'cancel-discount-button'"></button>
                        <!-- Apply Discount Submit Button -->
                        <button (click)="StaffDiscountBreakup()" [loading]="applyDiscountBtnLoading" [disabled]="inValidDiscount || inValidRecurringDiscount" pButton type="button" label="{{'common.PLACEHOLDER.APPLY' | translate}}" class="text-sm p-button-text" [attr.aria-label]="'apply-discount-submit-button'" [attr.data-testid]="'apply-discount-submit-button'"></button>
                      </div>
                    </div>
                  }
                  <!-- Discount Area -->
                } @else {
                  @if ((showSkeleton$ | async) || (showSkeletonForBillDetails$ | async)) {
                    <div class="border-1 border-300 border-round text-sm surface-0">
                      <div class="px-3 py-2 flex align-items-center justify-content-between">
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      </div>
                      <div class="px-3 py-2 flex align-items-center justify-content-between">
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      </div>
                      <div class="px-3 py-2 flex align-items-center justify-content-between">
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      </div>
                      <div class="px-3 py-2 flex align-items-center justify-content-between">
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      </div>
                      <div class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom mt-2">
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                        <p-skeleton * styleClass="w-4rem" height="1.35rem" />
                      </div>
                    </div>
                  } @else {
                    @if (subscriptionPlanId === 0 && (showSkeleton$ | async) === false) {
                      <div class="border-1 border-300 border-round text-sm surface-0 font-bold p-5 text-center">
                        <div>{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}</div>
                        <img  src="/assets/img/empty-favorite-img.svg" title="{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}" alt="{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}" />
                      </div>
                    }
                  }
                }
              </div>
              <!-- Bill Details -->
              <!-- Bill Details-skeleton -->
              <ng-template #showskeleton>
                @if ((showSkeleton$ | async) || (showSkeletonForBillDetails$ | async)) {
                  <div class="border-1 border-300 border-round text-sm surface-0">
                    <div class="px-3 py-2 flex align-items-center justify-content-between">
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                    </div>
                    <div class="px-3 py-2 flex align-items-center justify-content-between">
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                    </div>
                    <div class="px-3 py-2 flex align-items-center justify-content-between">
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                    </div>
                    <div class="px-3 py-2 flex align-items-center justify-content-between">
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                    </div>
                    <div class="px-3 py-2 flex align-items-center justify-content-between surface-900 text-white border-round-bottom mt-2">
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      <p-skeleton * styleClass="w-4rem" height="1.35rem" />
                    </div>
                  </div>
                } @else {
                  @if (subscriptionPlanId === 0 && (showSkeleton$ | async) === false) {
                    <div class="border-1 border-300 border-round text-sm surface-0 font-bold p-5 text-center">
                      <div>{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}</div>
                      <img src="/assets/img/empty-favorite-img.svg" title="{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}" alt="{{'POS.MEMBERSHIP_ADDON.PLEASE_SELECT_PRODUCT' | translate}}" />
                    </div>
                  }
                }
              </ng-template>
              <!-- Bill Details-skeleton -->
              <!-- Details -->
              @if (isContract$.getValue()) {
                <div class="flex mt-3 surface-0 border-1 border-300 border-round shadow-2">
                  <div class="w-6 px-3 md:px-4 py-2 border-right-1 border-300">
                    <h5 class="text-base mb-2 font-normal">
                      {{'POS.MEMBERSHIP_ADDON.PAYING_TODAY' | translate}}
                    </h5>
                    @if ((showSkeletonForBillDetails$ | async) === false) {
                      <div>
                        @if (totalOneTimeCost$ | async; as totalOneTimeCost) {
                          <strong class="text-lg block line-height-1">
                            {{ totalOneTimeCost | currencyformat}}
                          </strong>
                        }
                        <i class="block text-600 text-xxs">{{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}</i>
                      </div>
                    }
                    @if ((showSkeletonForBillDetails$  | async)) {
                      <p-skeleton styleClass="w-4rem" height="1.35rem" />
                    }
                  </div>
                  @if (billingSignupMode !== signUpMode.MidCycleAddons) {
                    <div class="w-6 px-3 md:px-4 py-2">
                      <h5 class="text-base mb-2 font-normal">
                        {{'POS.MEMBERSHIP_ADDON.RECURRING' | translate}}
                      </h5>
                      @if ((showSkeletonForBillDetails$ | async) === false) {
                        <div>
                          @if (recurringCost$ | async; as recurringCost) {
                            <strong class="text-lg block line-height-1 mb-1">
                              {{ recurringCost | currencyformat }}
                            </strong>
                          }
                          <i class="block text-600 text-xxs"> {{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}</i>
                          <div>
                            @if (this.billingInterval && this.biilingIntervalType) {
                              <i class="block text-xs mt-1">
                                {{ 'POS.MEMBERSHIP_ADDON.EVERY' | translate}} {{ (this.billingInterval> 1)? this.billingInterval.toString() : ""}} {{ 'POS.MEMBERSHIP_ADDON.' +
                                this.getInterval(this.billingInterval,this.biilingIntervalType) | translate}}
                              </i>
                            }
                          </div>
                        </div>
                      }
                      @if ((showSkeletonForBillDetails$ | async)) {
                        <p-skeleton styleClass="w-4rem" height="1.35rem" />
                      }
                    </div>
                  }
                  @if (billingSignupMode === signUpMode.MidCycleAddons) {
                    <div class="w-6 px-3 py-2 border-left-1 border-300">
                      {{'POS.MEMBERSHIP_ADDON.RECURRING' | translate}}
                      @if ((showSkeletonForBillDetails$ | async) === false) {
                        <div class="flex align-items-center">
                          <span class="block">
                            {{ existingRecurringCost$ | currencyformat }}
                          </span>
                          <i class="fa-solid fa-circle-arrow-right text-primary mx-2"></i>
                          <strong> {{ (addonRecurringCost$ + existingRecurringCost$) | currencyformat }}</strong>
                        </div>
                      }
                      @if (showSkeleton) {
                        <p-skeleton width="4rem" height="1.35rem" />
                      }
                      @if (!showSkeleton) {
                        <i class="text-xxs text-500 block mt-2">{{'POS.MEMBERSHIP_ADDON.PRICEWITHTAX' | translate}}</i>
                      }
                      @if (!showSkeleton && this.billingInterval && this.biilingIntervalType) {
                        <i  class="block text-xs mt-1">
                          {{ 'POS.MEMBERSHIP_ADDON.EVERY' | translate}} {{ (this.billingInterval> 1)? this.billingInterval.toString() : ""}} {{ 'POS.MEMBERSHIP_ADDON.' +
                          getInterval(this.billingInterval,this.biilingIntervalType) | translate }}
                        </i>
                      }
                      @if (showSkeleton) {
                        <p-skeleton width="6rem" height="1rem" styleClass="mt-1" />
                      }
                    </div>
                  }
                </div>
              }
              <!-- Details -->
            </div>
            <!-- Bill Owner and Date -->
            @if (!isCartFlow()) {
              <div [ngClass]="boolshowSessionOwner ? 'rtl-row-reverse' : '' " class="surface-0 px-3 py-2 flex justify-content-between flex-wrap border-top-1 border-300">
                <div [ngClass]="boolshowSessionOwner ? 'w-12 md:w-6 my-2' : 'w-12 md:w-6 my-2'" class="md:pr-2">
                  <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
                    {{'POS.MEMBERSHIP_ADDON.BILL_DATE' | translate}}
                  </h5>
                  @if ((showSkeleton$ | async) === false) {
                    <p-datepicker [showIcon]="true"
                      formControlName="billdate"
                      [readonlyInput]="true"
                      placeholder="{{'common.PLACEHOLDER.SELECT_DATE' | translate}}"
                      inputStyleClass="text-sm w-full"
                      styleClass="w-full"
                      (onSelect)="GetRevisedPrice_OnStartDateChange()"
                      [minDate]="minStartDate"
                      [maxDate]="maxStartDate"
                      [attr.aria-label]="'select-bill-date-calendar'"
                      [attr.data-testid]="'select-bill-date-calendar'" />
                  }
                  @if ((showSkeleton$ | async)) {
                    <p-skeleton width="100%" height="1.35rem" />
                  }
                </div>
                <div class="w-12 md:w-6 my-2 md:pr-2">
                  <label for="billowner" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate}}</label>
                  @if ((showSkeleton$ | async) === false) {
                    <staff-selector [formGroup]="fg"
                      [controlName]="billingOwner"
                      [id]="_selectedstaff"
                      [styleClass]="'w-full text-sm'"
                      [placeHolder]="'CreateEditStaff.SELECT_PLACEHOLDER' | translate"
                      [filterstaff]="_filterStaff" />
                  }
                  @if (billingOwner.dirty && billingOwner.invalid) {
                    <app-error-msg [errors]="billingOwner.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.BILL_OWNER' | translate" />
                  }
                  @if ((showSkeleton$ | async)) {
                    <p-skeleton width="100%" height="2rem" />
                  }
                </div>
                @if (boolshowSessionOwner) {
                  <div class="w-12 md:w-6 my-2 md:pl-2">
                    <label for="assign_owner" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.SESSION_OWNER'| translate}}</label>
                    @if ((showSkeleton$ | async) === false) {
                      <p-button (click)="showSessionOwnerModel()"
                        icon="fa fa-users"
                        label="{{'POS.MEMBERSHIP_ADDON.ASSIGN_SESSION_OWNER' | translate}}"
                        styleClass="p-button-outlined text-xs"
                        [disabled]="isOverlapping"
                        [attr.aria-label]="'assign-session-owner-button'"
                        [attr.data-testid]="'assign-session-owner-button'" />
                    }
                    @if ((showSkeleton$ | async)) {
                      <p-skeleton width="100%" height="2rem" />
                    }
                  </div>
                }
                @if (keyFobRequired.value && !isAmendmentSignupMode()) {
                  <div class="w-12 md:w-6 my-2">
                    <label for="keyfob" class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate}}</label>
                    <!-- Button Selection -->
                    @if ((showSkeleton$ | async) === false && showDigitalKeyFob.value) {
                      <div class="p-buttonset white-space-nowrap mb-2">
                        <button pButton pRipple type="button" [ngClass]="digitalKeyFOBSelected ? 'bg-primary' : 'surface-600' " (click)="toggleKeyFobSelectionType(true,false)" class="border-right-1 border-white text-sm" [label]="'POS.MEMBERSHIP_ADDON.DIGITAL_BTN' | translate" [attr.aria-label]="'select-digital-key-fob-button'" [attr.data-testid]="'select-digital-key-fob-button'"></button>
                        <button pButton pRipple type="button" [ngClass]="physicalKeyFOBSelected ? 'bg-primary' : 'surface-600' " (click)="toggleKeyFobSelectionType(false,true)" class="border-right-1 border-white text-sm" [label]="'POS.MEMBERSHIP_ADDON.PHYSICAL_BTN' | translate" [attr.aria-label]="'select-physical-key-fob-button'" [attr.data-testid]="'select-physical-key-fob-button'"></button>
                      </div>
                    }
                    <!-- Input Field -->
                    <div>
                      @if ((showSkeleton$ | async) === false && physicalKeyFOBSelected) {
                        <input type="text" class="w-full text-sm" formControlName="keyfob" pInputText [attr.aria-label]="'enter-key-fob-number-input'" [attr.data-testid]="'enter-key-fob-number-input'"/>
                      }
                      @if ((showSkeleton$ | async)) {
                        <p-skeleton width="100%" height="1.35rem" />
                      }
                    </div>
                    <!-- Keyfob validation feedback -->
                    @if (isValidatingKeyfob && physicalKeyFOBSelected) {
                      <div class="flex align-items-center mt-2 text-sm text-600">
                        <i class="pi pi-spin pi-spinner mr-2"></i>
                        <span>Validating keyfob...</span>
                      </div>
                    }
                    @if (!isValidatingKeyfob && keyfobValidationMessage && keyFobFormControl.value && keyFobFormControl.value !== clientKeyfob && physicalKeyFOBSelected) {
                      <div
                        [ngClass]="{'text-green-600': isKeyfobValid, 'text-red-600': !isKeyfobValid}"
                        class="flex align-items-center mt-2 text-sm">
                        <i [ngClass]="{'pi pi-check-circle': isKeyfobValid, 'pi pi-times-circle': !isKeyfobValid}" class="mr-2"></i>
                        <span>{{keyfobValidationMessage}}</span>
                      </div>
                    }
                    @if (keyFobFormControl.invalid && keyFobFormControl.dirty && !digitalKeyFOBSelected) {
                      <app-error-msg [errors]="keyFobFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate" />
                    }
                  </div>
                }
                <!-- <div class="w-12 md:w-6 my-2 md:pl-2" *ngIf="keyFobRequired">
                <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate}}</label>
                <input type="text" *ngIf="(showSkeleton$ | async) === false" class="w-full text-sm" formControlName="keyfob" pInputText />
                <app-error-msg *ngIf="keyFobFormControl.invalid && keyFobFormControl.dirty" [errors]="keyFobFormControl.errors" [fieldLabel]="'POS.MEMBERSHIP_ADDON.KEY_FOB_NUMBER' | translate"> </app-error-msg>
                <p-skeleton *ngIf="(showSkeleton$ | async)" width="100%" height="1.35rem"></p-skeleton>
              </div> -->
              <div class="w-12 my-2">
                <label for="client" class="font-medium text-700 text-xs mb-2 block white-space-nowrap uppercase">{{'Shared.CREATE-PROSPECT.REFERRED_BY' | translate}}</label>
                @if ((showSkeleton$ | async) === false) {
                  <mini-search class="w-full text-sm relative" [readonly]="referredByClientId > 0 ? true : false" [showSelected]="true" [clientId]="referredByClientId" (clients)="GetClientReferrel($event)" (removedClient)="removeClient($event)" />
                }
                @if ((showSkeleton$ | async)) {
                  <p-skeleton width="100%" height="2rem" />
                }
              </div>
              <!-- Bill Owner and Date -->
            </div>
          }
          <!-- Bill Owner and Date -->
          <!-- Upgrade Calculation -->
          @if (billingSignupMode === signUpMode.Upgrade) {
            <upgrade-membership-info [showSkeleton]="showSkeleton$"
              [showInfo]="false"
              [showCalculation]="true"
              [planMaster]="(selectedPlanDetail$ | async)"
              [fromSubscription]="fromSubscription"
              [subscriptionStartDate]="subscriptionStartdate.value"
              [upgardePlanBreakUpResponse]="upgradePlanBreakUpCalculationResponse$" />
          }
          <!-- <upgrade-calculation-info *ngIf="billingSignupMode == signUpMode.Upgrade"></upgrade-calculation-info> -->
          <!-- Upgrade Calculation -->
        </div>
        <!-- Mid Part -->
      </div>
    </div>
  }
</div>
<!-- Content -->

<!-- Footer -->
@if (hasbillingRights && (showSkeletonForBillDetails$ | async) === false) {
  <div class="sticky bottom-0 left-0 w-full z-3 border-top-1 border-300">
    <div class="surface-200 p-1-5">
      <!-- Primary Action Button -->
      <div class="mb-1">
        @if (isCartFlow()) {
          <p-button [loading]="isSubmitting | async"
            (onClick)="addToCard();"
            [disabled]="isBtnDisabled()"
            styleClass="w-full h-2-5rem text-sm font-semibold"
            severity="primary"
            [attr.aria-label]="'add-to-cart-button'"
            [attr.data-testid]="'add-to-cart-button'">
            <ng-template pTemplate="content">
              <i class="fa fa-cart-shopping text-base mr-2" style="pointer-events: none;"></i>
              <span style="pointer-events: none;">{{'RETAIL_PRODUCTS.ADD_TO_CART' | translate}}</span>
            </ng-template>
          </p-button>
        }
        @if (isCartFlow() === false) {
          <p-button [loading]="isSubmitting | async"
            (onClick)="SaveSubscription(false, null);"
            [disabled]="isOnlineBtnDisabled() || !tenantDetails.is_paymentgateway_configured"
            styleClass="w-full h-2-5rem text-sm font-semibold"
            severity="success"
            [attr.aria-label]="'continue-online-payment-button'"
            [attr.data-testid]="'continue-online-payment-button'">
            <ng-template pTemplate="content">
              <i class="fa fa-credit-card text-base mr-2" style="pointer-events: none;"></i>
              <span style="pointer-events: none;">{{'POS.MEMBERSHIP_ADDON.CONTINUE_ONLINE_PAYMENT' | translate}}</span>
            </ng-template>
          </p-button>
        }
      </div>
      <!-- Secondary Action Buttons -->
      <div class="flex flex-column gap-1">
        <!-- POS Terminal Button -->
        @if (showChargeOnPosTerminal.value && isSupportedPlan() && !isCartFlow()) {
          <div class="border-bottom-1 border-200 pb-1">
            <p-button pRipple (onClick)="PosDeviceSignup()"
              [loading]="isSubmitting | async"
              [pTooltip]="getTooltip() | translate"
              tooltipPosition="top"
              [disabled]="isOfflineBtnDisabled()"
              styleClass="w-full h-2rem text-sm"
              severity="secondary"
              [attr.aria-label]="'charge-on-pos-button'"
              [attr.data-testid]="'charge-on-pos-button'">
              <ng-template pTemplate="content">
                <img width="14" src="assets/img/icons/icon-terminal.svg" alt="POS Terminal" class="mr-2" style="pointer-events: none;" />
                <span style="pointer-events: none;">{{'POS_DEVICE.CHARGE_ON_POS' | translate }}</span>
              </ng-template>
            </p-button>
          </div>
        }
        <!-- Saved Payment Methods Button -->
        @if (showPayViaSavedPaymentMethods && isCartFlow() === false) {
          <p-button (onClick)="OpenSavedPaymentMethods()"
            [loading]="isSubmitting | async"
            [disabled]="isOnlineBtnDisabled()"
            styleClass="w-full h-2rem text-sm hover:shadow-2 transition-all transition-duration-200"
            severity="secondary"
            [attr.aria-label]="'pay-with-saved-card-button'"
            [attr.data-testid]="'pay-with-saved-card-button'">
            <ng-template pTemplate="content">
              <div class="flex align-items-center justify-content-center w-full" style="pointer-events: none;">
                <i class="fa fa-credit-card text-base mr-2"></i>
                <span class="font-medium">{{'POS.MEMBERSHIP_ADDON.PAY_WITH_SAVED_METHOD' | translate}}</span>
              </div>
            </ng-template>
          </p-button>
        }
        <!-- Offline Payment Button -->
        @if (isCartFlow() === false) {
          <p-button (onClick)="OpenOtherPayment()"
            [loading]="isSubmitting | async"
            [pTooltip]="getDisableBtnTooltip() | translate"
            [disabled]="isOfflineBtnDisabled()"
            styleClass="w-full h-2rem text-sm hover:shadow-2 transition-all transition-duration-200"
            severity="secondary"
            [attr.aria-label]="'record-offline-payment-button'"
            [attr.data-testid]="'record-offline-payment-button'">
            <ng-template pTemplate="content">
              <div class="flex align-items-center justify-content-center w-full" style="pointer-events: none;">
                <i class="fa fa-money-bill-wave text-base mr-2"></i>
                <span class="font-medium">{{'common.BUTTONS.RECORD_OFFLINE_PAYMENT_BTN' | translate}}</span>
              </div>
            </ng-template>
          </p-button>
        }
      </div>
      <!-- Signup Completion Section -->
      @if (showSIgnupComplition.value && isCartFlow() === false) {
        <div class="flex align-items-center justify-content-center mt-2 pt-1 border-top-1 border-200">
          <h6 class="text-xs font-normal mb-0 mr-2">{{'POS_DEVICE.SIGNUP_COMPLITION' | translate}}</h6>
          <p-select [options]="CompilationTargets" formControlName="target_device" optionLabel="value" filterBy="value" styleClass="text-xs h-1-5rem" dropdownIcon="fa fa-caret-down text-primary">
            <ng-template pTemplate="selectedItem">
              @if (CompilationTargetFormControl.value) {
                <strong class="text-primary text-xs">{{CompilationTargetFormControl.value.value}}</strong>
              }
            </ng-template>
            <ng-template let-signup pTemplate="item">
              <div class="text-xs">{{signup.value}}</div>
            </ng-template>
          </p-select>
        </div>
      }
    </div>
    <!-- Message -->
    @if (!isCartFlow()) {
      <div class="">
        <p-message severity="warn" aria-label="digital-waiver-message">
          <div class="p-warn flex align-items-center w-full -my-2">
            <i class="fa fa-exclamation-circle p-warn text-xl"></i>
            <div class="ml-3 line-height-3 text-xs">
              <strong class="block">{{'POS.MEMBERSHIP_ADDON.DIGITALWAIVER' | translate}}</strong>
              <span>{{'POS.MEMBERSHIP_ADDON.DIGITALWAIVER_LINE' | translate}}</span>
            </div>
          </div>
        </p-message>
      </div>
    }
    <!-- Message -->
  </div>
}
<!-- Footer -->

@if (showSkeletonForBillDetails$ | async) {
  <div class="sticky bottom-0 right-0 w-full text-center p-3 surface-400">
    <p-skeleton styleClass="w-full" height="2rem" />
  </div>
}
</form>
</ng-template>
</p-drawer>

<!-- Apply Coupon Modal  -->
<p-dialog [visible]="applyCouponModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '450px'}" styleClass="no-header-modal overflow-visible">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
      <h2 class="mb-0 text-sm">{{'POS.MEMBERSHIP_ADDON.APPLY_COUPON' | translate}}</h2>
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closeCouponPopup()"></i>
    </div>
    <!-- Header -->

    <!-- Modal Content -->
    <div class="surface-100 border-bottom-1 border-300 p-3 md:p-4 flex align-items-center">
      <input type="text" #couponText pInputText class="w-full text-sm" [(ngModel)]="couponCode" [placeholder]="'POS.MEMBERSHIP_ADDON.COUPON_PLACEHOLDER' | translate" [attr.aria-label]="'enter-coupon-code-input'" [attr.data-testid]="'enter-coupon-code-input'"/>
      <p-button styleClass="text-sm ml-3" type="submit" [label]="'common.BUTTONS.BTN_APPLY' | translate" (click)="AddCouponCode(couponText.value,true)" [attr.aria-label]="'apply-coupon-code-button'" [attr.data-testid]="'apply-coupon-code-button'" />
    </div>
    <!-- Modal Content -->

    <!-- Modal Content -->
    <div class="p-3 md:p-4">
      <h6 class="text-sm mb-3">{{'POS.MEMBERSHIP_ADDON.CHOOSE_COUPON' | translate}}</h6>
      @if (couponCollection.length > 0) {
        <p-scrollPanel styleClass="h-12rem">
          @for (coupon of couponCollection; track coupon) {
            <div
              (click)="AddCouponCode(coupon.value,false)"
              [ngClass]="Appliedcoupon(coupon.value) ? 'border-primary' :''"
              class="flex align-items-center justify-content-between border-2 p-2 border-dotted border-300 border-round mt-2 cursor-pointer"
              [attr.aria-label]="'select-coupon-'+coupon.name"
              [attr.data-testid]="'select-coupon-'+coupon.name">
              <div class="text-sm">{{coupon.name}}</div>
              <div class="ml-2 text-primary border-1 border-primary border-round p-2 surface-0 font-bold text-xs">{{coupon.value}}</div>
            </div>
          }
        </p-scrollPanel>
      } @else {
        <div class="h-10rem text-sm flex align-items-center justify-content-center">{{'POS.MEMBERSHIP_ADDON.COUPON_UNAVAILABLE' | translate}}</div>
      }
    </div>
    <!-- Modal Content -->
  </ng-template>
</p-dialog>
<!-- Apply Coupon Modal  -->


<!-- Payment Failed Modal  -->
@if (paymentFailed) {
  <p-dialog [visible]="paymentFailed" [resizable]="false" appendTo="body" [modal]="true"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" show styleClass="no-header-modal overflow-visible">
    <ng-template pTemplate="header" styleClass="hidden" />
    <!-- Header -->
    <div class="p-3 align-items-center justify-content-between border-bottom-1 border-300 text-right">
      <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePaymentFailed()" [attr.aria-label]="'close-payment-failed-dialog'"></i>
    </div>
    <!-- Header -->
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Modal Content -->
      <div class="p-5 text-center">
        <i class="fa fa-times-circle p-error text-8xl"></i>
        <h5 class="text-lg p-error mb-3 mt-5">{{'POS_DEVICE.PAYMENT_FAILED' | translate}}</h5>
        @if (paymentFailedMessages.length > 0) {
          @for (message of paymentFailedMessages; track message) {
            <p class="mb-5">{{ message }}</p>
          }
        } @else {
          <p class="mb-5">{{'POS_DEVICE.FAILED_REASON' | translate}}</p>
        }
        <p-button [label]="'POS_DEVICE.RETRY_PAYMENT' | translate" (click)="RetryPayment()" styleClass="text-sm w-12rem" [attr.aria-label]="'retry-payment-button'" [attr.data-testid]="'retry-payment-button'" />
      </div>
      <!-- Modal Content -->
    </ng-template>
  </p-dialog>
}
<!-- Payment Failed Modal -->

<!-- Transaction In Progress Modal  -->
@if (transactionInProcess) {
  <p-dialog [visible]="transactionInProcess" [resizable]="false" appendTo="body" [modal]="true"
    [closeOnEscape]="false" [dismissableMask]="false" [blockScroll]="true" [closable]="false" [baseZIndex]="12000"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible">
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Modal Content -->
      <div class="p-5 text-center">
        <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="4" animationDuration=".5s" />
        <h5 class="text-lg p-error mb-3 mt-5">{{'POS_DEVICE.TRANSACTION_PROGRESS' | translate}}</h5>
        <p class="mb-5">{{'POS_DEVICE.DO_NOT_CLOSE' | translate}}</p>
      </div>
      <!-- Modal Content -->
    </ng-template>
  </p-dialog>
}
<!-- Transaction In Progress Modal -->

<!-- Online payment confirmation modal (POS / card on file) -->
@if (paymentConfirmationPending) {
  <p-dialog [visible]="paymentConfirmationPending" [resizable]="false" appendTo="body" [modal]="true"
    [closeOnEscape]="paymentConfirmationTimedOut" [dismissableMask]="false" [blockScroll]="true" [baseZIndex]="12000"
    [breakpoints]="{'767px': '100vw'}" [style]="{width: '550px'}" styleClass="no-header-modal overflow-visible"
    [closable]="false">
    @if (paymentConfirmationTimedOut) {
      <div class="p-3 align-items-center justify-content-end border-bottom-1 border-300 text-right">
        <button type="button" class="border-none bg-transparent p-0 cursor-pointer"
          (click)="closePaymentConfirmationTimeout()"
          [attr.aria-label]="'close-payment-confirmation-timeout-dialog'"
          [attr.data-testid]="'close-payment-confirmation-timeout-dialog'">
          <i class="fa fa-times text-xl text-600"></i>
        </button>
      </div>
    } @else {
      <ng-template pTemplate="header" styleClass="hidden" />
    }
    <ng-template pTemplate="content" styleClass="p-0">
      <div class="p-5 text-center" data-testid="payment-confirmation-dialog">
        @if (paymentConfirmationTimedOut) {
          <i class="fa fa-clock-o text-orange-500 text-8xl"></i>
          <h5 class="text-lg text-orange-500 mb-3 mt-5">{{ paymentConfirmationTimeoutMessage }}</h5>
        } @else {
          <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="4" animationDuration=".5s" />
          <h5 class="text-lg mb-3 mt-5">{{'POS_DEVICE.CONFIRMING_PAYMENT_STATUS' | translate}}</h5>
          @if (paymentConfirmationShowTimeLimit) {
            <p class="mb-2 font-semibold text-primary" data-testid="payment-confirmation-countdown">
              {{ 'POS_DEVICE.PAYMENT_TIME_REMAINING' | translate: { time: paymentConfirmationCountdownDisplay } }}
            </p>
            <p class="mb-3 text-sm text-600">{{ 'POS_DEVICE.PAYMENT_TIME_LIMIT_INFO' | translate }}</p>
          }
          <p class="mb-5">{{'POS_DEVICE.DO_NOT_CLOSE' | translate}}</p>
        }
      </div>
    </ng-template>
  </p-dialog>
}
<!-- Online payment confirmation modal -->

@if (showErrorPopup | async; as showPopup) {
  <app-errors [error]="error" [visible]="showPopup"   [errorData]="errorMessages" (hideErrorPopup)="HideErrorPopup($event)" />
}

@if (showOtherPaymentsModel$ | async) {
  <other-payment [otherPaymentsModal]="showOtherPaymentsModel$ | async"
    [isCashRecurring]="true"
    [totalAmtTobePaid]="paymentAmount"
    [showCreditBalance]="true"
    [creditBalance]="creditBalance"
    [tenantId]="billedAtTenantId()"
    [minimumPaymentRequiredPerc]="planDetail.minimum_payment_required_in_percentage"
    [IsMinimumPaymentRequired]="IsMinimumPaymentRequired"
    [showCreditBalanceForClientCredit]="false"
    (hideOtherPaymentDialog)="HideOtherPaymentDialog($event)"
    (closeOtherPaymentDialog)="closeOtherPaymentDialog($event)" />
}

@if (showSessionOwnerChangeModel$ | async) {
  <change-session-owner [visible]="showSessionOwnerChangeModel$ | async"  
    [planMaster]="planDetail"
    [planBreakUp]="planBreakUpCalculation$ | async"
    (closeChangeSessionOwnerDialogEvent)="closeChangeSessionOwnerDialogEvent($event)" />
}

@if (showAddonsSidebar) {
  <billing-add-on [visible]="showAddonsSidebar"  [tenantId]="tenantId" [planId]="subscriptionPlanId" [mode]="'billing'"
    [selectedAddons]="selectedAddons" (closeAddonSidebar)="closeAddonSidebar($event)" />
}

@if (showDeviceList) {
  <pos-device-list
    [visible]="showDeviceList"
    [loadReady]="posGatewaysLoaded"
    [tenantId]="tenantId"
    [activeOnly]="true"
    [autoSelectSingle]="true"
    (closeDevicesPopup)="closeDevicesPopup($event)" />
}

<!-- Product Fulfillment Popup -->
@if (showProductFulfillmentPopup.value) {
  <product-fulfillment-popup [visible]="showProductFulfillmentPopup.value"
    [products]="productFulfillmentItems"
    (confirmFulfillment)="onProductFulfillmentConfirm($event)"
    (cancelFulfillment)="onProductFulfillmentCancel()" />
}

<!-- Saved Payment Methods Popup -->
@if (showSavedPaymentMethodsPopup.value) {
  <saved-payment-methods-popup [visible]="showSavedPaymentMethodsPopup.value"
    [clientId]="clientId"
    [tenantId]="tenantId"
    [currencyCode]="countryCode"
    (paymentMethodSelected)="onSavedPaymentMethodSelected($event)"
    (hideDialog)="onSavedPaymentMethodsPopupClosed()" />
}


